import {
  success as notifySuccess,
  warning as notifyWarning,
} from 'app/services/snugNotifier'

export interface PmsDeactivateResponseBody {
  warning?: string
}

/** Call after successful POST /pms/.../deactivate/... (response body may include `warning`). */
export function notifyPmsDeactivateOutcome(
  pmsBrand: string,
  responseBody: PmsDeactivateResponseBody | undefined | null,
): void {
  const warnMsg = responseBody?.warning
  if (warnMsg) {
    notifyWarning(warnMsg)
    return
  }
  notifySuccess(`${pmsBrand} deactivated successfully!`)
}

/** For flows that do not show a success toast; only surfaces API warning when present. */
export function notifyPmsDeactivateWarningOnly(
  responseBody?: PmsDeactivateResponseBody | null,
): void {
  const warnMsg = responseBody?.warning
  if (warnMsg) {
    notifyWarning(warnMsg)
  }
}
